import React, { ReactNode } from 'react';
import { useQuery } from '@apollo/client';
import { CircularProgress, Stack } from '@mui/material';
import { CalendarEventsPeriod } from '@trnsact/trnsact-shared-types';
import { RenderWithFallback } from 'components/shared/Conditional/RenderWithFallback';

import { calendarApi } from '../../api';
import { useEventIdParam } from '../../hooks';
import { CalendarEventMapper } from './mapper';
import { CalendarEvent, CalendarEventEntity, CalendarViewProps } from './types';
import { QueryListResponse } from '../../../../../global';
import { DealActivityAPINameSpace } from '../../../api/types';

interface Props {
  period: CalendarEventsPeriod;
  children: (props: CalendarViewProps) => ReactNode;
}

export const CalendarConnector = ({ period, children }: Props) => {
  const { openEvent } = useEventIdParam();

  const { data, previousData, error, loading } = useQuery<
    DealActivityAPINameSpace<QueryListResponse<CalendarEventEntity>>
  >(calendarApi.listOfCalendarEvents, {
    variables: {
      input: {
        period,
      },
    },
  });

  const eventsList = (data ?? previousData)?.dealActivity?.result?.list || [];

  const events = CalendarEventMapper.mapToCalendarEvent(eventsList);

  const handleSelectEvent = (event: CalendarEvent) => {
    openEvent(event.id);
  };

  return (
    <RenderWithFallback
      error={error}
      isLoading={loading && !eventsList.length}
      fallBack={
        <Stack alignItems="center" justifyContent="center" height="100%">
          <CircularProgress />
        </Stack>
      }
    >
      {children({ events, onSelectEvent: handleSelectEvent })}
    </RenderWithFallback>
  );
};
